import {
  getProductProperty,
  getTwoProductProperty,
} from "@scenes/findMatch/Utils/ProductDetailList/utils";
import { ProductCategory } from "@utils/constants";
import currency from "currency.js";
import {
  checkCenterStoneValue,
  checkProductDetailValue,
  checkSideStoneValue,
  checkValidationValue,
  getLocationProperty,
} from "./utils";

export const getProductDetailsArray = (itemDetail: any, productType: any) => [
  {
    id: 1,
    title: "Lab",
    description: getProductProperty(itemDetail?.lab, ""),
    icon: "upd-diamonds",
  },
  {
    id: 2,
    title: "Report #",
    description: getProductProperty(itemDetail?.cert_num, ""),
    icon: "upd-gemstones",
  },
  {
    id: 3,
    title: "Shape",
    description: getProductProperty(itemDetail?.shape, ""),
    icon: "upd-jewelry",
  },
  {
    id: 4,
    title: "Carat",
    description: getProductProperty(itemDetail?.size, ""),
    icon: "upd-labGrown",
  },
  {
    id: 5,
    title: "Color",
    description: getProductProperty(
      productType === ProductCategory.LAB_GROWN_DIAMOND ||
        productType === ProductCategory.DIAMOND
        ? itemDetail?.fancy_color_intensity
          ? itemDetail?.fancy_color_intensity +
            " " +
            itemDetail?.fancy_color_long
          : itemDetail?.fancy_color_long &&
            itemDetail?.fancy_color_long !== null
          ? itemDetail?.fancy_color_long
          : itemDetail?.color
        : itemDetail?.color,
      ""
    ),
    icon: "upd-labGrown",
  },
  {
    id: 124,
    title: "Clarity",
    description: getProductProperty(itemDetail?.clarity, ""),
    icon: "upd-labGrown",
  },
  {
    id: 6,
    title: "Cut",
    description: getProductProperty(itemDetail?.cut, ""),
    icon: "upd-labGrown",
  },
  {
    id: 7,
    title: "Polish",
    description: getProductProperty(itemDetail?.polish, ""),
    icon: "upd-labGrown",
  },
  {
    id: 8,
    title: "Sym",
    description: getProductProperty(itemDetail?.symmetry, ""),
    icon: "upd-labGrown",
  },
  {
    id: 9,
    title: "Fluor",
    description: getProductProperty(itemDetail?.fluor_intensity, ""),
    icon: "upd-labGrown",
  },
  {
    id: 20,
    title: "Location",
    description: getTwoProductProperty(
      itemDetail?.city,
      "",
      itemDetail?.country,
      ""
    ),
    icon: "upd-labGrown",
  },
  {
    id: 10,
    title: "Depth",
    description: getProductProperty(itemDetail?.depth_percent, "%"),
    icon: "upd-labGrown",
  },
  {
    id: 11,
    title: "Table",
    description: getProductProperty(
      currency(itemDetail?.table_percent, {
        symbol: "",
        precision: 0,
      }).format(),
      "%"
    ),
    icon: "upd-labGrown",
  },
  {
    id: 12,
    title: "Girdle",
    description: getProductProperty(itemDetail?.girdle_condition, ""),
    icon: "upd-labGrown",
  },
  {
    id: 13,
    title: "Crown",
    description: getTwoProductProperty(
      itemDetail?.crown_height,
      "%",
      itemDetail?.crown_angle,
      "°"
    ),
    icon: "upd-labGrown",
  },
  {
    id: 14,
    title: "Pavillion",
    description: getTwoProductProperty(
      itemDetail?.pavilion_depth,
      "%",
      itemDetail?.pavilion_angle,
      "°"
    ),
    icon: "upd-labGrown",
  },

  {
    id: 15,
    title: "Culet",
    description: getProductProperty(itemDetail?.culet_size, ""),
    icon: "upd-labGrown",
  },
  {
    id: 16,
    title: "Meas",
    description: getProductProperty(itemDetail?.measurement, ""),
    icon: "upd-labGrown",
  },
  {
    id: 17,
    title: "Ratio",
    description: getProductProperty(itemDetail?.meas_ratio, ""),
    icon: "upd-labGrown",
  },
  {
    id: 18,
    title: "BGM",
    description: getProductProperty(itemDetail?.bgm, ""),
    icon: "upd-labGrown",
  },
  {
    id: 19,
    title: "Treat",
    description: getProductProperty(itemDetail?.treatment, ""),
    icon: "upd-labGrown",
  },
  {
    id: 20,
    title: "Growth Type",
    description: getProductProperty(itemDetail?.growth_type, ""),
    icon: "upd-labGrown",
    showNumber: productType === ProductCategory.LAB_GROWN_DIAMOND,
  },

  // Add more items as needed
];

export const getSupplierArray = (
  localSelectedLocation: any,
  showNumber: any,
  isCustomApp?: boolean
) => {
  const array = [];
  if (isCustomApp) {
    array.push({
      id: 122,
      title: "Email",
      color: "link-static",
      emailClickable: true,
      description:
        getLocationProperty(localSelectedLocation, "contact_email", "") || "-",
      icon: "upd-labGrown",
    });
  }
  array.push(
    {
      id: 123,
      title: "Address",
      description:
        getLocationProperty(localSelectedLocation, "street_address", "") || "-",
      icon: "upd-diamonds",
    },
    {
      id: 132,
      title: "City",
      description:
        getLocationProperty(localSelectedLocation, "city", "") || "-",
      icon: "upd-gemstones",
    },
    {
      id: 124,
      title: "State",
      description:
        getLocationProperty(localSelectedLocation, "state", "") || "-",
      icon: "upd-jewelry",
      showNumber: localSelectedLocation?.state ? true : false,
    },
    {
      id: 125,
      title: "Zip",
      description: getLocationProperty(localSelectedLocation, "zip", "") || "-",
      icon: "upd-labGrown",
      showNumber: localSelectedLocation?.zip ? true : false,
    },
    {
      id: 126,
      title: "Country",
      description:
        getLocationProperty(localSelectedLocation, "country", "") || "-",
      icon: "upd-labGrown",
    },
    {
      id: 127,
      title: "Contact",
      description:
        getLocationProperty(localSelectedLocation, "contact_person", "") || "-",
      icon: "upd-labGrown",
      showNumber: checkValidationValue(
        localSelectedLocation,
        showNumber,
        "contact_person"
      ),
    },
    {
      id: 128,
      title: "Office",
      description:
        getLocationProperty(
          localSelectedLocation,
          "office_phone",
          "contact_phone_country_code"
        ) || "-",
      color: "link-static",
      icon: "upd-labGrown",
      clickable: true,
      showNumber: checkValidationValue(
        localSelectedLocation,
        showNumber,
        "office_phone"
      ),
    },
    {
      id: 129,
      title: "Mobile",
      description:
        getLocationProperty(
          localSelectedLocation,
          "mobile_phone",
          "mobile_phone_country_code"
        ) || "-",
      color: "link-static",
      icon: "upd-labGrown",
      clickable: true,
      showNumber: checkValidationValue(
        localSelectedLocation,
        showNumber,
        "mobile_phone"
      ),
    }
  );
  return array;
};

export const getProductGemstoneDetailsArray = (itemDetail: any) => [
  {
    id: 1,
    title: "Type",
    description: getProductProperty(itemDetail?.gem_type, ""),
    icon: "upd-diamonds",
  },
  {
    id: 2,
    title: "Color",
    description: getProductProperty(itemDetail?.color, ""),
    icon: "upd-gemstones",
  },
  {
    id: 3,
    title: "Shape",
    description: getProductProperty(itemDetail?.shape, ""),
    icon: "upd-jewelry",
  },
  {
    id: 4,
    title: "Carat",
    description: getProductProperty(itemDetail?.size, ""),
    icon: "upd-labGrown",
  },
  {
    id: 9,
    title: "Treat",
    description: getProductProperty(itemDetail?.treatment, ""),
    icon: "upd-labGrown",
  },
  {
    id: 13,
    title: "Location",
    description: getTwoProductProperty(
      itemDetail?.city,
      "",
      itemDetail?.country,
      ""
    ),
    icon: "upd-labGrown",
  },
  {
    id: 5,
    title: "Lab",
    description: getProductProperty(itemDetail?.lab, ""),
    icon: "upd-labGrown",
  },
  {
    id: 14,
    title: "Report #",
    description: getProductProperty(itemDetail?.cert_num, ""),
    icon: "upd-gemstones",
  },
  {
    id: 73,
    title: "Origin",
    description: getProductProperty(itemDetail?.country_of_origin, ""),
    icon: "upd-labGrown",
  },
  {
    id: 7,
    title: "Meas",
    description: getProductProperty(itemDetail?.measurement, ""),
    icon: "upd-labGrown",
  },
  {
    id: 8,
    title: "Ratio",
    description: getProductProperty(itemDetail?.meas_ratio, ""),
    icon: "upd-labGrown",
  },
  {
    id: 10,
    title: "Treatment Notes",
    description: getProductProperty(itemDetail?.treatment_notes, "%"),
    icon: "upd-labGrown",
  },
  // Add more items as needed
];

export const getProductJewelryDetailsArray = (itemDetail: any) => [
  {
    id: 1,
    title: "Type",
    description: getProductProperty(itemDetail?.jewelry_style, ""),
    icon: "upd-diamonds",
    showNumber: checkProductDetailValue(itemDetail, itemDetail?.jewelry_style),
  },
  {
    id: 2,
    title: "Carat",
    description: getProductProperty(itemDetail?.size, ""),
    icon: "upd-gemstones",
    showNumber: checkProductDetailValue(itemDetail, itemDetail?.size),
  },
  {
    id: 3,
    title: "Metal",
    description: getProductProperty(itemDetail?.metals, ""),
    icon: "upd-jewelry",
    showNumber: checkProductDetailValue(itemDetail, itemDetail?.metals),
  },
  {
    id: 31,
    title: "Brand",
    description: getProductProperty(itemDetail?.brand, ""),
    icon: "upd-jewelry",
    showNumber: checkProductDetailValue(itemDetail, itemDetail?.brand),
  },
  {
    id: 32,
    title: "Location",
    description:
      getProductProperty(itemDetail?.city, "") +
      ", " +
      getProductProperty(itemDetail?.country, ""),
    icon: "upd-jewelry",
    showNumber: checkProductDetailValue(
      itemDetail,
      itemDetail?.city,
      itemDetail?.country
    ),
  },
  {
    id: 4,
    title: "Description",
    description: getProductProperty(itemDetail?.jewelry_description, ""),
    icon: "upd-labGrown",
    showNumber: checkProductDetailValue(
      itemDetail,
      itemDetail?.jewelry_description
    ),
  },
  {
    id: 5,
    title: "",
    description: "",
    icon: "upd-labGrown",
    showNumber: checkCenterStoneValue(itemDetail),
  },
  {
    id: 6,
    title: "Center Stone",
    description: "",
    isTitle: true,
    icon: "upd-labGrown",
    showNumber: checkCenterStoneValue(itemDetail),
  },
  {
    id: 7,
    title: "Shape",
    description: getProductProperty(itemDetail?.center_shape, ""),
    icon: "upd-labGrown",
    showNumber: checkCenterStoneValue(itemDetail, itemDetail?.center_shape),
  },
  {
    id: 8,
    title: "Carat Weight",
    description: getProductProperty(itemDetail?.center_size, ""),
    icon: "upd-labGrown",
    showNumber: checkCenterStoneValue(itemDetail, itemDetail?.center_size),
  },
  {
    id: 9,
    title: "Color",
    description: getProductProperty(itemDetail?.center_color, ""),
    icon: "upd-labGrown",
    showNumber: checkCenterStoneValue(itemDetail, itemDetail?.center_color),
  },
  {
    id: 10,
    title: "Clarity",
    description: getProductProperty(itemDetail?.center_clarity, ""),
    icon: "upd-labGrown",
    showNumber: checkCenterStoneValue(itemDetail, itemDetail?.center_clarity),
  },
  {
    id: 11,
    title: "",
    description: "",
    icon: "upd-labGrown",
    showNumber: checkSideStoneValue(itemDetail),
  },
  {
    id: 12,
    title: "Side Stone",
    description: "",
    isTitle: true,
    icon: "upd-labGrown",
    showNumber: checkSideStoneValue(itemDetail),
  },
  {
    id: 13,
    title: "Shape",
    description: getProductProperty(itemDetail?.side_stone_shape, ""),
    icon: "upd-labGrown",
    showNumber: checkSideStoneValue(itemDetail, itemDetail?.side_stone_shape),
  },
  {
    id: 14,
    title: "Color",
    description: getProductProperty(itemDetail?.side_stone_color, ""),
    icon: "upd-labGrown",
    showNumber: checkSideStoneValue(itemDetail, itemDetail?.side_stone_color),
  },
  // Add more items as needed
];
